import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { NetworkingService } from '../../_services/_content/networking.service';
import { ICollection, ICustomApp, INetworking, NavigationLinkType, NetworkingTool } from '@sv/interfaces';
import { Router } from '@angular/router';
import { ShepherdService } from 'angular-shepherd';
import { CustomAppService } from 'src/app/_services/_content/customApp.service';
import { TutorialService } from 'src/app/_services/_tutorial/tutorial.service';
import { NavigationService } from 'src/app/_services/_content/navigation.service';
import { EventAnalyticsService } from 'src/app/_services/_analytics/event-analytics.service';
import { CollectionService } from 'src/app/_services/_content/collection.service';

@Component({
  selector: 'app-networking',
  templateUrl: './networking.component.html',
  styleUrls: ['./networking.component.scss']
})
export class NetworkingComponent implements OnInit, AfterViewInit, OnDestroy {
  constructor(
    private networkingService: NetworkingService,
    private router: Router,
    private customAppService: CustomAppService,
    private shepherdService: ShepherdService,
    private tutorialService: TutorialService,
    private navigationService: NavigationService,
    private eventAnalyticsService: EventAnalyticsService,
    private collectionService: CollectionService
  ) {}

  activeNetworking: INetworking;
  collection: ICollection;

  NetworkingTool = NetworkingTool;

  app: ICustomApp;

  url: string;
  html = true;

  ngOnInit(): void {
    this.customAppService.getCustomAppListener().subscribe((app) => {
      this.app = app;
    });

    // get selected NetworkingModule from Service
    this.networkingService.getNetworkingListener().subscribe((networking) => {
      this.activeNetworking = networking;
      if (this.activeNetworking.partOfCollection) {
        this.collectionService.getCollectionListener().subscribe((collection) => {
          this.collection = collection;
          this.collection.backButtonText = this.collection.backButtonText ?? 'Zurück zur Übersicht';
        });
      }
    });

    this.url = this.activeNetworking.iFrameUrl;
    if (this.url.startsWith('http')) {
      this.html = false;
    }
  }

  async ngAfterViewInit(): Promise<void> {
    if (sessionStorage.getItem('tutorial') === null && sessionStorage.getItem('networking') === null) {
      this.shepherdService.addSteps(this.tutorialService.getNetworkingSteps());
      let navigation = this.app.navigation;
      if (typeof navigation === 'string') {
        navigation = await this.navigationService.getNavigationById(navigation);
      }
      this.shepherdService.tourObject.addStep(this.tutorialService.getNextModuleStep(navigation.links, NavigationLinkType.Networking));

      this.shepherdService.start();
    }
  }

  async ngOnDestroy(): Promise<void> {
    if (sessionStorage.getItem('tutorial') === null) {
      sessionStorage.setItem('networking', 'false');
      this.shepherdService.complete();
    }
    await this.eventAnalyticsService.newCollectionRoomView();
  }
}
